<script lang="ts" setup>
  import { hotkeysHelp } from '@/plugins/HotkeyPlugin.ts'
</script>

<template>
  <table class="min-w-full table-auto border border-gray-300 text-sm">
    <thead class="bg-gray-100 dark:bg-gray-900">
      <tr>
        <th class="px-4 py-2 text-left border-b border-gray-300">Tastenkürzel</th>
        <th class="px-4 py-2 text-left border-b border-gray-300">Beschreibung</th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="(hotkey, index) in hotkeysHelp"
        :key="index"
        class="hover:bg-gray-50 dark:hover:bg-gray-500">
        <td
          v-if="typeof hotkey === 'string'"
          class="text-center px-4 py-2 whitespace-nowrap border-b border-gray-200"
          colspan="2">
          <span class="font-semibold">{{ hotkey }}</span>
        </td>
        <template v-else>
          <td class="px-4 py-1 whitespace-nowrap border-b border-gray-200 font-mono text-sm">
            {{ hotkey.key }}
          </td>
          <td class="px-4 py-1 border-b border-gray-200">
            {{ hotkey.description }}
          </td>
        </template>
      </tr>
    </tbody>
  </table>
</template>
